import { defineStore } from 'pinia';
import { ref } from 'vue';

interface Notification {
  title: string;
  text: string;
  details?: string;
  type?: 'error' | 'success' | 'warning' | 'info';
  timeout?: number;
}

export const useNotificationStore = defineStore('notification', () => {
  const snackbar = ref({
    show: false,
    color: '',
    text: '',
    title: '',
    timeout: 5000,
    location: 'top right'
  });

  const showError = (notification: Omit<Notification, 'type'>) => {
    snackbar.value = {
      show: true,
      color: 'error',
      text: notification.text,
      title: notification.title,
      timeout: notification.timeout || 5000,
      location: 'top right'
    };
  };

  const showSuccess = (notification: Omit<Notification, 'type'>) => {
    snackbar.value = {
      show: true,
      color: 'success',
      text: notification.text,
      title: notification.title,
      timeout: notification.timeout || 3000,
      location: 'top right'
    };
  };

  const showWarning = (notification: Omit<Notification, 'type'>) => {
    snackbar.value = {
      show: true,
      color: 'warning',
      text: notification.text,
      title: notification.title,
      timeout: notification.timeout || 4000,
      location: 'top right'
    };
  };

  const showInfo = (notification: Omit<Notification, 'type'>) => {
    snackbar.value = {
      show: true,
      color: 'info',
      text: notification.text,
      title: notification.title,
      timeout: notification.timeout || 4000,
      location: 'top right'
    };
  };

  return {
    snackbar,
    showError,
    showSuccess,
    showWarning,
    showInfo
  };
}); 